module.exports = __webpack_public_path__ + "img/profile-icon.52d95495.svg";